import type { Locale } from "@/types/global";
import useIntlStore from "@/stores/useIntlStore";
import { useIntl } from "react-intl";
import zh_CN from "../../../locale/frontend/zh-CN.json";
import en_US from "../../../locale/frontend/en-US.json";
import ja_JP from "../../../locale/frontend/ja-JP.json";
import { setDefaultConfig } from "antd-mobile";
import antd_zhCN from "antd-mobile/es/locales/zh-CN";
import antd_enUS from "antd-mobile/es/locales/en-US";
import antd_jaJP from "antd-mobile/es/locales/ja-JP";

export type TransOption = {
  defaultMessage?: string;
  values?: Record<string, any>;
};

export const getIntlMessages = (locale: Locale) => {
  switch (locale) {
    case "zh-CN":
      return zh_CN;
    case "en-US":
      return en_US;
    case "ja-JP":
      return ja_JP;
    default:
      return zh_CN;
  }
};

/**
 * @description hooks 翻译函数
 */
export const useT = () => {
  const intl = useIntl();

  const t = (id: string, option = {} as TransOption) => {
    const { defaultMessage, values } = option;

    return intl.formatMessage({ id: id, defaultMessage }, values);
  };

  return t;
};

export const getT = () => {
  const t = (id: string, option = {} as TransOption) => {
    const { intl } = useIntlStore.getState();

    const { defaultMessage, values } = option;

    return intl.formatMessage({ id, defaultMessage }, values);
  };

  return t;
};

export const setAntdLocale = (locale: Locale) => {
  switch (locale) {
    case "en-US":
      setDefaultConfig({
        locale: antd_enUS,
      });
      break;
    case "zh-CN":
      setDefaultConfig({
        locale: antd_zhCN,
      });
      break;
    case "ja-JP":
      setDefaultConfig({
        locale: antd_jaJP,
      });
      break;
    default:
      setDefaultConfig({
        locale: antd_zhCN,
      });
      break;
  }
};
